
<template>
    <div class="row">
        <div class="col-md-12">
            <section class="panel">
                <header class="panel-heading">
                    <h2 class="panel-title">查詢條件</h2>
                </header>
                <div class="panel-body container-fluid">
                    <div class="row form-group">
                        <div class="col-md-12 form-group">
                            <label for="report" class="column-required">報表</label>
                            <select id="report" name="report" v-validate="'required'" v-model="form.report" class="form-control" :style="{width:'auto', display:'inline-block'}">
                                <option value="" >請選擇</option>
								<option v-for="(item,key) in reportList" :key="key" :value="item.key">{{ item.value }}</option>
                            </select>
                        </div>
                        <div class="col-md-12 form-group">
                            <label for="year" class="column-required">學年度</label>
                            <select id="year" name="year" v-validate="'required'" v-model="form.year" class="form-control" :style="{width:'auto', display:'inline-block'}">
                                <option value="">請選擇</option>
                                <option v-for="item in yearList" :key="item" :value="item">{{item}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="btn-group">
                        <button @click="handleDownload" class="btn s_btn_b">下載</button>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    data() {
		return {
            yearList: [],
			reportList: [
				{
					key: "1",
					value: "弱勢助學金申請統計表"
				},
				{
					key: "2",
					value: "弱勢助學金學生名冊"
				},
        {
          key: "3",
          value: "弱勢助學金學生名冊(日間部退費)"
        },
        {
          key: "4",
          value: "弱勢助學金學生名冊(日間部不退費)"
        },
        {
          key: "5",
          value: "弱勢助學金學生名冊(進修部退費)"
        },
        {
          key: "6",
          value: "弱勢助學金學生名冊(進修部不退費)"
        }
			],
            form: {
                report: "",
                year: "",
            }
		}
	},
    mounted() {
        this.$http.get("/api/weak/yearList").then((res) => {
            if(res.data.data.length > 0) {
                this.yearList = res.data.data;
                this.form.year = this.yearList[0];
            }
        });
    },
	methods: {
		handleDownload() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					const api = `/api/weak/export/report`;

                    const query = new URLSearchParams({
                        type: this.form.report,
                        year: this.form.year,
                    }).toString();
                    this.$axios.get(`${api}?${query}`, {
                        responseType: 'blob'
                    }).then(resp => {
                        const url = window.URL.createObjectURL(new Blob([resp.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        const reportName = this.reportList.find(r => r.key == this.form.report).value;
                        link.setAttribute('download', `弱勢_${this.form.year}_${reportName}_${this.customFormatter(new Date(),"YYYYMMDD")}.xlsx`);
                        document.body.appendChild(link);
                        link.click();
                    });
				} else {
					bootbox.alert("請確認必填欄位是否有填寫")
				}
			});
		}
	},
	computed:{
	}
}
</script>

<style scoped>
</style>
